import { render, staticRenderFns } from "./locale_changer.vue?vue&type=template&id=bababaa0&scoped=true"
import script from "./locale_changer.vue?vue&type=script&lang=js"
export * from "./locale_changer.vue?vue&type=script&lang=js"
import style0 from "./locale_changer.vue?vue&type=style&index=0&id=bababaa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bababaa0",
  null
  
)

export default component.exports